import cx from 'classnames';
import React from 'react';

import * as styles from './PlayIcon.module.css';

import Play from '@components/SVG/Play';

const PlayIcon = ({ className = '' }: { className?: string }): JSX.Element => {
	return (
		<div className={cx(styles.bounds, className)}>
			<Play className={styles.icon} />
		</div>
	);
};

export default PlayIcon;
